export default __webpack_public_path__ + "static/media/n_wdt_c_5.da077d7c.mp3";